import { Configuration } from '@/types/models';

export const configurationMapper = (data: Configuration): Record<string, unknown> => ({
  annotators: data.annotators,
  elementTypes: data.elementTypes,
  miramiTypes: data.miriamTypes,
  modelConverters: data.modelFormats,
  modificationStateTypes: data.modificationStateTypes,
  options: data.options,
  overlayTypes: data.overlayTypes,
  privilegeTypes: data.privilegeTypes,
  reactionTypes: data.reactionTypes,
});
